export const EXTENSION_OFFER_REASONS = {
  waiting_original: "Original staff didn't return from leave",
  waiting_replacement: 'Staff replacement not yet acquired',
  seasonal_spike: 'Prolonged seasonal census spike',
  contract_to_hire: 'Contract to hire candidate',
};

export const EXTENSION_OFFER_REASON_KEYS = Object.keys(EXTENSION_OFFER_REASONS);

export function getExtensionOfferReasonDescription(reason?: string) {
  if (!reason) return '';

  const _reason = reason as keyof typeof EXTENSION_OFFER_REASONS;
  return EXTENSION_OFFER_REASONS[_reason] || '';
}
